export default "__VITE_ASSET__erRVjJGT__"